// Marca erros lancados de proposito so para "pausar" o fluxo (modais de
// troca de pagamento, autorizacao etc). O beforeSend do Sentry usa essa
// marca para nao reportar como erro real.
const INTENTIONAL_FLOW_PAUSE_MARK = "__intentionalFlowPause";

// Generic sem constraint para acomodar `unknown` (catch em modo strict).
// O guard runtime garante que primitivos sao no-op silencioso — preservar
// a invariante "se nao da pra marcar, retorne o valor original e siga".
export function markIntentionalFlowPause<T>(err: T): T {
  if (err !== null && typeof err === "object") {
    try {
      Object.defineProperty(err, INTENTIONAL_FLOW_PAUSE_MARK, {
        value: true,
        enumerable: false,
        configurable: true,
        writable: true,
      });
    } catch {
      // Objeto frozen/sealed/Proxy estranho — nao consegue marcar.
      // AxiosError e Error nao sao frozen; se acontecer, ver um falso
      // positivo no Sentry e melhor que mascarar um erro real.
    }
  }
  return err;
}

export function isIntentionalFlowPause(err: unknown): boolean {
  return Boolean(
    err &&
      typeof err === "object" &&
      (err as Record<string, unknown>)[INTENTIONAL_FLOW_PAUSE_MARK]
  );
}
